import { SearchLoop } from '../../../../../assets/icons';
import StyledInput from '../../../../../components/styledInput/StyledInput';
import ThreeStateCheckbox from '../../../../../components/threeStateCheckbox/threeStateCheckbox';
import { SearchTypeSelect } from '../../qualification';

const HeaderQualification = ({ search, setSearch, optionSearch, setOptionSearch, showDisabled, setShowDisabled }) => (
  <div className="flex gap-2 items-center flex-1 min-w-0">
    <div className="flex-1 min-w-[120px] max-w-[400px]">
      <StyledInput
        type="text"
        placeholder="Rechercher..."
        imgFront={<SearchLoop wh={16} color="#6B7280" />}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
    </div>
    <div className="flex-shrink-0 max-w-[200px]">
      <SearchTypeSelect value={optionSearch} onChange={setOptionSearch} />
    </div>
    <div className="border rounded px-4 h-10 flex items-center hover:bg-gray-100 transition-colors flex-shrink-0">
      <label className="flex items-center gap-2 cursor-pointer">
        <ThreeStateCheckbox checked={showDisabled} onChange={setShowDisabled} />
        <span className="whitespace-nowrap text-sm">Désactivé</span>
      </label>
    </div>
  </div>
);

export default HeaderQualification;
